import React, { useRef } from 'react';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import AdditionalIntl from '../../I18n/AdditionalIntl/AdditionalIntl';
import I18n from '../../I18n/I18n/I18n';
import en from './locales/ObjectFieldTemplate.en.json';
function collectProperties(props) {
  var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (!props) {
    return acc;
  }
  Object.keys(props).reduce(function (acc, key) {
    var name = path + key;
    acc.push(name);
    var prop = props[key];
    if (prop.type === 'array') {
      collectProperties(prop.items.properties, acc, name + ':');
    } else if (prop.type === 'object') {
      collectProperties(prop.properties, acc, name + ':');
    }
    return acc;
  }, acc);
  return acc.sort();
}
function propDiff(oldProps, newProps) {
  var result = {
    added: [],
    removed: []
  };
  var oldIndex = 0;
  var newIndex = 0;
  while (oldIndex < oldProps.length && newIndex < newProps.length) {
    var oldProp = oldProps[oldIndex];
    var newProp = newProps[newIndex];
    if (oldProp === newProp) {
      oldIndex++;
      newIndex++;
    } else if (!newProp || oldProp < newProp) {
      result.removed.push(oldProp);
      oldIndex++;
    } else if (!oldProp || oldProp > newProp) {
      result.added.push(newProp);
      newIndex++;
    } else {
      oldIndex++;
      newIndex++;
    }
  }
  return result;
}
function schemaDiff(oldSchema, newSchema) {
  var oldProps = collectProperties(oldSchema);
  var newProps = collectProperties(newSchema);
  return propDiff(oldProps, newProps);
}
var messages = normalizeLocaleData(en, '@dm/components.objectFieldTemplate');
export default function (_ref) {
  var isTopLevel = _ref.isTopLevel,
    schema = _ref.schema;
  var schemaRef = useRef(schema);
  var diffRef = useRef({
    added: [],
    removed: []
  });
  if (isTopLevel) {
    try {
      var diff = schemaDiff(schemaRef.current.properties, schema.properties);
      if (diff.added.length > 0 || diff.removed.length > 0) {
        diffRef.current = diff;
      }
    } catch (e) {
      // FS-4639 - https://watermarkinsights.atlassian.net/browse/FS-4639
      // CVI creates invalid arrays properties when it edits a single field
      //	no need to add change notification as only one field be in the schema
    }
  }
  schemaRef.current = schema;
  if (!isTopLevel) {
    return null;
  }
  return /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: messages,
    namespace: "@dm/components.objectFieldTemplate"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sr-only",
    "aria-live": "polite"
  }, diffRef.current.added.length > 0 && /*#__PURE__*/React.createElement(I18n, {
    i18n: {
      id: '@dm/components.objectFieldTemplate.fields-added',
      values: {
        count: diffRef.current.added.length
      }
    }
  }), diffRef.current.removed.length > 0 && /*#__PURE__*/React.createElement(I18n, {
    i18n: {
      id: '@dm/components.objectFieldTemplate.fields-removed',
      values: {
        count: diffRef.current.removed.length
      }
    }
  })));
}